export * from './faq.component';
export * from './faq.route';
export * from './faq.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/faq/index.ts